import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-1.5" };
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Badge } from "@eudonet/opal";
import { formatMonthYear } from "@/shared/utils/date-formatting";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactRelationFunctionRow',
    props: {
        fn: {}
    },
    setup(__props) {
        const props = __props;
        const { t, locale } = useI18n();
        // The backend derives the current/past state (end date empty OR in the future) —
        // an end date alone does not make a function past (R42).
        const isPast = computed(() => !props.fn.isCurrent);
        const periodText = computed(() => {
            // Legacy roles created before the Relations module may carry no start date —
            // skip the period rather than rendering an invalid date.
            const datePart = !props.fn.startDate
                ? ""
                : isPast.value
                    ? t("contact.detail.relations.function.period", {
                        from: formatMonthYear(props.fn.startDate, locale.value),
                        to: formatMonthYear(props.fn.endDate, locale.value),
                    })
                    : t("contact.detail.relations.function.since", {
                        date: formatMonthYear(props.fn.startDate, locale.value),
                    });
            return [props.fn.category, datePart].filter(Boolean).join(" · ");
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Badge), {
                    type: "with-dot",
                    theme: isPast.value ? 'neutral' : 'green',
                    label: __props.fn.title,
                    "show-close-icon": false,
                    size: "sm"
                }, null, 8 /* PROPS */, ["theme", "label"]),
                _createElementVNode("p", {
                    class: _normalizeClass([
                        'text-xs',
                        isPast.value
                            ? 'text-(--text-text-disabled-light)'
                            : 'text-(--text-text-body-subtle)',
                    ])
                }, _toDisplayString(periodText.value), 3 /* TEXT, CLASS */)
            ]));
        };
    }
});
